// 集中维护“计算结果”与“输入参数”标签映射，避免各处分支遗漏

// 通用结果标签（各保护类型共享）
export const COMMON_RESULT_LABELS = {
  pickupCurrent: '启动电流 (A)',
  timeMultiplier: '时间倍数 (TMS)',
  curveType: '曲线类型',
  secondaryCurrent: '二次故障电流 (A)',
  sensitivity: '灵敏度系数',
  zone1Setting: '第I段阻抗定值 (Ω)',
  zone2Setting: '第II段阻抗定值 (Ω)',
  zone3Setting: '第III段阻抗定值 (Ω)',
  secondaryImpedance: '二次故障阻抗 (Ω)',
  reach: '保护范围',
  operateTime: '动作时间 (s)',
  secondaryVoltage: '二次电压 (V)',
  direction: '方向',
  polarizingAngle: '极化角 (°)',
  zeroSequenceCurrent: '零序电流 (A)',
  differentialCurrent: '差流 (A)',
  operatingCharacteristic: '动作特性',
  axesType: '坐标系类型',
  lineAngleDeg: '线路阻抗角 (°)',
  zones: '分段区设置',
  characteristic: '动作特性参数',
  // 新增通用结果标签补充
  baseImpedanceMode: '基准阻抗模式',
  lineImpedanceSecondary: '线路阻抗 (Ω,二次值)',
  voltageLow: '二次电压不足',
  k0: '零序比例系数 k0',
  restraintCurrent: '制动电流 (A)'
};

// 各保护类型的专用或覆盖标签
export const TYPE_RESULT_LABEL_OVERRIDES = {
  differential: {
    differentialInstantaneous: '差动速断电流 (A,一次值)',
    diffInstantaneousSecondary: '差动速断电流 (A,二次值)',
    differentialCurrentSetting: '差动电流定值 (A)',
    restraintSlope: '比率制动斜率',
    secondHarmonicBlocking: '二次谐波制动系数',
    ctRatio: 'CT变比',
    transformerCapacity: '变压器容量 (kVA)'
  },
  overcurrent: {
    instantaneousPickup: '瞬时阈值电流 (A,二次值)',
    baseLoadCurrent: '负荷基准电流 (A,一次值)',
    pickupMultiplier: '启动倍数 (×)',
    instantaneousMultiplier: '瞬时倍数 (×)'
  }
};

// 获取统一结果标签（优先类型覆盖，其次通用，最后回退原键）
export const getResultLabel = (key, protectionType) => {
  const overrides = TYPE_RESULT_LABEL_OVERRIDES[protectionType] || {};
  return overrides[key] || COMMON_RESULT_LABELS[key] || key;
};

// 通用参数标签（输入参数）
export const COMMON_PARAM_LABELS = {
  systemVoltage: '系统电压',
  ratedCurrent: '额定电流',
  ctRatio: 'CT变比',
  ptRatio: 'PT变比',
  faultCurrent: '故障电流',
  transformerCapacity: '变压器容量',
  protectionType: '保护类型',
  curveType: '反时限曲线族',
  timeMultiplier: '时间倍数 (TMS)'
};

// 各类型的参数标签覆盖或特有项
export const TYPE_PARAM_LABEL_OVERRIDES = {
  directional: {
    polarizingAngle: '极化角 (°)'
  },
  zero_sequence: {
    k0: '零序比例系数 k0'
  },
  distance: {
    lineAngleDeg: '线路阻抗角 (°)',
    selectedFeederId: '馈线',
    lineRX_ohm: '线路参数 R/X (Ω)'
  },
  overcurrent: {
    maxLoadCurrent: '最大负荷电流 (A,一次值)',
    pickupMultiplier: '启动倍数 (×)',
    instantaneousMultiplier: '瞬时倍数 (×)'
  }
};

// 获取统一参数标签
export const getParamLabel = (key, protectionType) => {
  const overrides = TYPE_PARAM_LABEL_OVERRIDES[protectionType] || {};
  return overrides[key] || COMMON_PARAM_LABELS[key] || key;
};